import _ from 'lodash';

import { createService as baseCreateService } from '@narrate/base-sdk';

import profile from './ProfileService';
import account from './AccountService';
import accessBlock from './AccessBlockService';
import homeFeed from './HomeFeedService';
import conversations from './ConversationService';
import search from './SearchService';
import photo from './PhotoService';
import media from './MediaService';
import transactions from './TransactionService';
import notifications from './NotificationsService';
import report from './ReportService';
import ephemeralKey from './EphemeralKeyService';

const services = {
  conversations,
  profile,
  account,
  accessBlock,
  ephemeralKey,
  homeFeed,
  search,
  photo,
  media,
  transactions,
  notifications,
  report,
};

const appVersion = '1.1.0';
const appFeatures = ['subscriptions'];

export function createService() {
  const coreService = baseCreateService({ appVersion, appFeatures });

  _.each(services, (ServiceClass, name) => {
    const service = new ServiceClass();
    coreService.register(name, service);
    service.AppVersion = appVersion;
    service.AppFeatures = appFeatures;
  });
  return coreService;
}

const DefaultCore = createService();

export { configureMobile } from '@narrate/base-sdk';
export { configure } from '@narrate/base-sdk';
export default DefaultCore;
